import React, { ReactNode } from 'react'
import { PixelRatio } from 'react-native'

import { Notice } from 'APP/Store/Content/types'
import { Images } from 'APP/Themes'
import ContentCardNotice from './ContentCardNotice'
import {
  ContentCardContainer,
  ContentContainer,
  Content,
  ImageContainer,
  Image,
  StyledTag,
} from './style'
import Typography from '../Typography'

interface ContentCardProps {
  title: string
  onPress: () => void
  icon: ReactNode
  info: string
  imageUrl: string
  notice?: Notice | null
  testID?: string
  tag?: string
  maxWidth: number
}

const ContentCard: React.FC<ContentCardProps> = ({
  title,
  onPress,
  icon,
  info,
  imageUrl,
  tag,
  notice,
  maxWidth = 300,
  testID = 'CONTENT_CARD',
}) => {
  const imageWidth = PixelRatio.getPixelSizeForLayoutSize(maxWidth)
  const imageURI = `${imageUrl}?w=${imageWidth}`

  return (
    <ContentCardContainer
      onPress={onPress}
      width={maxWidth}
      testID={testID}
      accessibilityRole="button"
      accessibilityLabel={title}
    >
      <ImageContainer>
        <Image
          source={{ uri: imageURI, cache: 'force-cache' }}
          defaultSource={Images.contentLoading}
          resizeMode="cover"
        />
      </ImageContainer>
      <ContentContainer maxWidth={maxWidth}>
        <Typography variant="h4">{title}</Typography>
        <Content>
          {icon}
          <Typography variant="bodySmall">{info}</Typography>
          {tag && <StyledTag testID="CONTENT_CARD_TAG">{tag}</StyledTag>}
        </Content>
      </ContentContainer>
      {!!notice && <ContentCardNotice {...notice} />}
    </ContentCardContainer>
  )
}

export default ContentCard
